import CheckIcon from 'assets/images/check_icon.svg?react';

interface CheckBoxPropsType {
  agree: boolean;
  onClick: () => void;
}

export default function CheckBox({agree, onClick}: CheckBoxPropsType) {
  return (
    <div className="relative h-[18px] w-[16px] rounded-lg border-b-2 border-[#C3B9A8]">
      {agree ? (
        <>
          <div className="h-full w-full rounded-lg border-2 border-[#6B2D1A]" />
          <button
            onClick={onClick}
            className="absolute -top-[11px] -left-[5px]">
            <CheckIcon width={29} height={25} />
          </button>
        </>
      ) : (
        <button
          onClick={onClick}
          className="h-full w-full rounded-lg border-2 border-[#6B2D1A]"
        />
      )}
    </div>
  );
}
